<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Vessel Type Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.vesType }}</td>
            <td class="text-xs-left">{{ props.item.vesTypeDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['vesselReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Vessel Type
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="typeDialog" width="800px" lazy v-if="checkAccess(['vesselReview'])" persistent >
        <type-dialog :typeForm="typeForm" @close="doClose" :newType="newType"></type-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Vessel Type? ({{deleteVesType}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import TypeDialog from './TypeDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Vessel Type Code', align: 'left', value: 'vesType' },
        { text: 'Vessel Type Description', align: 'left', value: 'vesTypeDesc' }
      ],
      typeForm: {
        vesType: undefined,
        vesTypeDesc: undefined
      },
      typeDialog: undefined,
      newType: undefined,
      loading: false,
      promptRemove: false,
      selectedVesType: undefined,
      deleteVesType: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      const apiUrl = this.$store.state.vessel.menu.getVslTypes
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((VslType) => {
              const convertVslType = {
                vesType: VslType.vesType,
                vesTypeDesc: VslType.vesTypeDesc
              }
              this.items.push(convertVslType)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Type) {
      const apiURI = this.$store.state.vessel.menu.getVslType
      const expand = {
        vesType: Type.item.vesType
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.typeForm.vesType = data.vesType.vesType
          this.typeForm.vesTypeDesc = data.vesType.vesTypeDesc
        }
        this.typeDialog = true
      }
    },
    doClose() {
      this.typeDialog = false
      this.newType = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.typeDialog = true
      this.newType = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVesType = data
        this.deleteVesType = data.vesType + ' - ' + data.vesTypeDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.vessel.menu.deleteType
      if (apiURI) {
        const expand = this.selectedVesType
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.fetchData()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['vesselReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    TypeDialog: TypeDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
